import React, { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';

export type EditorSelectOption = { label: string; value: string };
export type EditorSelectOptions = EditorSelectOption[];

import { commonComponentsRegistry } from '../../../registry/CommonRegistry';

const InputSelectExtended = commonComponentsRegistry.getLazyComponent('InputSelectExtended');

export const EditorInputSelect = ({
    label,
    options = [],
    initialValue,
    required = false,
    handleChange,
}: {
    label: string;
    options: { label: string; value: string }[];
    initialValue?: string;
    required: boolean;
    handleChange: (value: string) => void;
}) => {
    const intl = useIntl();

    const optionFromInitialValue = useMemo(() => {
        if (initialValue && options.find((el) => el.value === initialValue)) {
            return options.find((el) => el.value === initialValue);
        }

        return options[0];
    }, [initialValue, options]);

    const { control, watch } = useForm({
        defaultValues: { select: optionFromInitialValue },
        criteriaMode: 'all',
    });

    React.useEffect(() => {
        const subscription = watch((data: any) => {
            handleChange(data.select.value);
        });
        return () => subscription.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watch, handleChange]);

    return (
        <InputSelectExtended
            options={options}
            label={label}
            components={{
                Option: (o) => <span>{intl.formatMessage({ id: o.option.label })}</span>,
            }}
            getSearch={(o) => intl.formatMessage({ id: o.label })}
            rules={{ required }}
            hideDeleteIcon={true}
            required={required}
            control={control}
            name={'select'}
        />
    );
};
